import { render, staticRenderFns } from "./ExpandMultiIcon.vue?vue&type=template&id=2bfcc720&scoped=true&"
import script from "./ExpandMultiIcon.vue?vue&type=script&lang=js&"
export * from "./ExpandMultiIcon.vue?vue&type=script&lang=js&"
import style0 from "./ExpandMultiIcon.vue?vue&type=style&index=0&id=2bfcc720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfcc720",
  null
  
)

export default component.exports